import { NoPlaceZoneBooking } from "../../Booking-Form/typings/booking-service-administration.types";
import { BookingScheduleInterface } from "../../Booking-Form/typings/booking.types";
import { FirstAidOptions } from "../partial/ScheduleFirstAidSelect.partial";

type P = {
  placeScheduleData: BookingScheduleInterface[] | undefined;
  noPlaceZoneBookingScheduleData: NoPlaceZoneBooking[] | undefined;
  setFirstAidOptions: (opt: Array<FirstAidOptions>) => void;
};

export function handleFirstAidScheduleOptions({
  placeScheduleData,
  noPlaceZoneBookingScheduleData,
  setFirstAidOptions
}: P) {
  let options: Array<FirstAidOptions> = [];

  // Exclude Mobile Working
  const filterMobileWorkingData = (data: any[]) =>
    data.filter(
      data => data.locationName !== "Mobile Working" && data.floorName !== "Mobile Working"
    );

  if (placeScheduleData && noPlaceZoneBookingScheduleData) {
    options = [
      ...filterMobileWorkingData(placeScheduleData).map(data => ({
        locationName: data.locationName ?? "",
        floorName: data.floorName
      })),
      ...filterMobileWorkingData(noPlaceZoneBookingScheduleData).map(data => ({
        locationName: data.locationName ?? "",
        floorName: data.floorName
      }))
    ];
    options = Array.from(new Map(options.map(option => [JSON.stringify(option), option])).values());
  }

  setFirstAidOptions(options);
}
